import { TableCell, TableRow, Typography } from '@mui/material'
import { FC } from 'react'
import { Message } from '../../api/models'
import { useRouteLocation } from '../../hooks/useRouteLocation'
import { formatIsoTimestampForLocation } from '../../utils/dateUtils'

export const SMS_TIME_FORMAT = 'tt ZZZZ'

interface AlarmSmsTableEntryProps {
  contactFirstName: string
  message: Message
}

function maskPhoneNumber(phoneNumber: string = ''): string {
  // +16179810791 -> ***-***-0791
  return `***-***-${phoneNumber.slice(-4)}`
}

export const AlarmSmsTableEntry: FC<AlarmSmsTableEntryProps> = ({ contactFirstName, message }) => {
  const { timestamp, direction, phoneNumber, message: body } = message
  const location = useRouteLocation()
  const humanTime = formatIsoTimestampForLocation(timestamp, location, { format: SMS_TIME_FORMAT })

  return (
    <TableRow sx={{ verticalAlign: 'top' }}>
      <TableCell align="left" data-testid={`sms-entry-time-${timestamp}`}>
        {humanTime}
      </TableCell>
      <TableCell align="left">
        <Typography>
          {direction === 'sent' ? 'to' : 'from'} {contactFirstName}
        </Typography>
        <Typography variant="body2">({maskPhoneNumber(phoneNumber)})</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography style={{ whiteSpace: 'pre-line' }}>{body}</Typography>
      </TableCell>
    </TableRow>
  )
}
